import { InflateStream } from "zlibt2";
import { MultiplayerBasePayloadType } from "../types/Multiplayer.types";
import { Buffer } from "buffer";

export const getDesignStateFromMessage = (
  payload: MultiplayerBasePayloadType
) => {
  const newDesignStateCompressedBased64 = payload.designState;
  const newDesignStateCompressedBuffer = Buffer.from(
    newDesignStateCompressedBased64,
    "base64"
  );

  const uint8Array = new Uint8Array(newDesignStateCompressedBuffer);
  const inflatedBuffer = new InflateStream(uint8Array);
  const decompressed = inflatedBuffer.decompress(uint8Array);
  const buffer = Buffer.from(decompressed.buffer);
  const str = buffer.toString("utf8");
  const newDesignState = JSON.parse(str.replace(/\0+$/, ""));
  return newDesignState;
};
